module.exports = require("react-copy-to-clipboard");